import { motion } from "framer-motion";

// New logo URL
const LOGO_URL = "https://customer-assets.emergentagent.com/job_d0bad9e2-9541-4321-bb8f-95b930b33ba5/artifacts/1zu4orzc_Where%20Was%20I%20logo.png";

// Logo variants for different contexts
export const LogoIcon = ({ 
  size = 40, 
  animated = false, 
  pulse = false,
  className = "" 
}) => {
  return (
    <motion.img
      src={LOGO_URL}
      alt="Where was i logo"
      width={size}
      height={size}
      className={`object-contain ${className}`}
      initial={animated ? { opacity: 0, scale: 0.8 } : false}
      animate={pulse ? { 
        scale: [1, 1.05, 1],
        opacity: [1, 0.9, 1]
      } : animated ? { opacity: 1, scale: 1 } : false}
      transition={pulse ? { 
        duration: 2, 
        repeat: Infinity, 
        ease: "easeInOut" 
      } : { duration: 0.5, ease: "easeOut" }}
    />
  );
};

// Logo with wordmark
export const LogoWithWordmark = ({ 
  size = 40, 
  animated = false,
  className = "" 
}) => {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <LogoIcon size={size} animated={animated} />
      <motion.span 
        className="font-semibold text-[#27272A]"
        style={{ fontSize: size * 0.45 }}
        initial={animated ? { opacity: 0, x: -10 } : false}
        animate={animated ? { opacity: 1, x: 0 } : false}
        transition={{ duration: 0.4, delay: 0.3 }}
      >
        Where was i
      </motion.span>
    </div>
  );
};

// Reset animation variant - calming breath animation (~3-4 seconds)
export const LogoResetAnimation = ({ size = 80, onComplete }) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.9 }}
      transition={{ duration: 0.5 }}
      className="relative flex items-center justify-center"
      onAnimationComplete={() => {
        // Trigger completion after full animation cycle (~3.5s)
        setTimeout(() => {
          if (onComplete) onComplete();
        }, 3000);
      }}
    >
      {/* Outer breathing ring */}
      <motion.div
        className="absolute rounded-full border-2 border-[#3DC4D0]/30"
        style={{ width: size * 1.8, height: size * 1.8 }}
        animate={{
          scale: [1, 1.2, 1],
          opacity: [0.3, 0.6, 0.3],
        }}
        transition={{
          duration: 3,
          ease: "easeInOut",
          times: [0, 0.5, 1],
        }}
      />
      
      {/* Middle breathing ring */}
      <motion.div
        className="absolute rounded-full border-2 border-[#0CBCBF]/40"
        style={{ width: size * 1.4, height: size * 1.4 }}
        animate={{
          scale: [1, 1.15, 1],
          opacity: [0.4, 0.7, 0.4],
        }}
        transition={{
          duration: 3,
          ease: "easeInOut",
          delay: 0.2,
          times: [0, 0.5, 1],
        }}
      />
      
      {/* Logo with subtle pulse */}
      <motion.img
        src={LOGO_URL}
        alt="Where was i logo"
        width={size}
        height={size}
        className="object-contain relative z-10"
        animate={{ 
          scale: [1, 1.08, 1],
        }}
        transition={{ 
          duration: 3,
          ease: "easeInOut",
          times: [0, 0.5, 1],
        }}
      />
      
      {/* Soft glow effect */}
      <motion.div
        className="absolute rounded-full bg-[#F58227]/10 blur-xl"
        style={{ width: size * 1.2, height: size * 1.2 }}
        animate={{
          scale: [1, 1.3, 1],
          opacity: [0.2, 0.5, 0.2],
        }}
        transition={{
          duration: 3,
          ease: "easeInOut",
          times: [0, 0.5, 1],
        }}
      />
    </motion.div>
  );
};

export default LogoIcon;
